module.exports = __webpack_public_path__ + "img/main-section.14b96306.jpg";